<div
    class="p-3"
    style="overflow-y: auto; max-height: 85vh;"
>
    <div
        class="close-modal"
        (click)="onClose()"
        (keydown.escape)="onClose()"
        tabindex="0"
    >
        <mat-icon>close</mat-icon>
    </div>

    <h1>{{ form.get('name')?.value || '' }}</h1>

    <div class="learning-section-options mt-4">
        <button
            mat-stroked-button
            color="primary"
            (click)="addContainer()"
            class="mb-3"
        >
            <mat-icon>add</mat-icon> Container hinzufügen
        </button>
        <mat-checkbox
            [checked]="showContainerId()"
            (change)="toggleContainerId()"
        >
            Container-ID anzeigen
        </mat-checkbox>
        @if (this.getPreviewLink()) {
        <a
            mat-flat-button
            color="primary"
            href="{{ this.getPreviewLink() }}"
            target="_blank"
        >
            <mat-icon>remove_red_eye</mat-icon> VORSCHAU
        </a>
        }


        <mat-form-field>
            <mat-label>Layout</mat-label>
            <mat-select
                [(value)]="selectedLayoutOption"
                (selectionChange)="onChangeLayout($event.value)"
            >
                @for (learningSectionLayout of learningSectionLayouts$ | async; track learningSectionLayout) {
                <mat-option [value]="learningSectionLayout">{{ learningSectionLayout.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div
        class="learning-section-grid-container"
        cdkDropList
        cdkDropListOrientation="mixed"
        [style.gridTemplateColumns]="gridTemplateColumns"
        (cdkDropListDropped)="drop($event)"
    >

        @for (container of learningSectionContainers; track container.id) {
        <div
            class="learning-section-grid-item"
            [style.grid-column]="container.fullWidth ? '1 / -1' : 'auto'"
            cdkDrag
            [cdkDragData]="container"
        >
            <div class="learning-section-grid-content">
                <span
                    title="Bearbeitung per Mausklick"
                    (click)="editLearningSectionSingleContainer(container)"
                    (keydown.enter)="
                            editLearningSectionSingleContainer(container)
                        "
                    tabindex="0"
                >
                    <div class="container-title">{{ container.title }}</div>
                    <div class="container-content">
                        <div class="name">{{ containerContentData[container.id]?.name }}</div>
                        <div class="type">{{ containerContentData[container.id]?.type }}</div>
                    </div>
                </span>
                <div
                    class="remove"
                    tabindex="0"
                    (click)="removeContainer(container)"
                    (keydown.enter)="removeContainer(container)"
                >
                    <mat-icon>close</mat-icon>
                </div>
                @if (showContainerId()) {
                <div
                    class="container-id"
                    title="Doppelklick zum Kopieren"
                    (dblclick)="copyContainerIdToClipboard(container.id)"
                >
                    {{ container.id }}
                </div>
                }
            </div>
        </div>
        }

    </div>
</div>